import styled from '@emotion/styled/macro';

import { Button } from 'components/buttons';

export const ActionPanel = styled.div(() => ({
  display: 'flex',
  justifyContent: 'flex-end',
}));

export const AddRecordButton = styled(Button)(() => ({
  textTransform: 'uppercase',
}));

export const SettlementContainer = styled.div<{ isPartner: boolean }>((props) => ({
  [props.theme.breakpoints.up('xl')]: {
    '& [data-column]': {
      width: props.isPartner ? '25%' : '20%',
    },
  },
}));

export const MemoPreview = styled.div(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: 3,
  span: {
    fontSize: 14,
  },
  path: {
    fill: theme.palette.text.secondary,
  },
}));

export const MemoControls = styled.div(() => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
}));

export const SecondaryText = styled.span(({ theme }) => ({
  color: theme.palette.text.secondary,
}));

export const EditMemoButton = styled(Button)(() => ({
  display: 'flex',
  marginLeft: 'auto',
  fontSize: 14,
  fontWeight: 500,
  span: {
    gap: 5,
  },
}));

export const StyledTooltip = styled.div((props) => ({
  display: 'flex',
  padding: 5,
  maxWidth: 400,
  border: `1px solid ${props.theme.colors.container.tertiary}`,
  borderRadius: 5,
  marginLeft: -15,
  marginBottom: 15,
  backgroundColor: props.theme.colors.background,
  boxShadow: '0px 3px 12px 0px rgba(41, 27, 79, 0.05)',
  fontSize: 12,
  fontWeight: 400,
  color: props.theme.colors.primary,
  fontFamily: props.theme.fonts.primary,
}));
